import imagesLoaded from 'imagesloaded';
import { setHeadHash } from 'src/js/lib/url.js';

export class SsCollection {
  constructor ( path, num ) {
    this.path = path;
    this.num = num;
    this.imgs = [];
    this.items = [];
  }

  load () {
    for ( let i = 0; i < this.num; i += 1 ) {
      const img = new Image();
      img.setAttribute(
        'src',
        `${ this.path }cover/l_${ i }.jpg`
      );
      this.imgs.push( img );
    }

    const imgLoad = imagesLoaded( this.imgs );
    return new Promise ( resolve => {
      imgLoad.on( 'done', () => {
        resolve();
      });
    });
  }

  makeDom () {
    if ( typeof this.dom === 'undefined' )
    {
      const flexElm = document.createElement( 'div' );
      flexElm.classList.add( 'collection-flex' );
      this.imgs.forEach( img => {
        const itemElm = document.createElement( 'div' );
        itemElm.classList.add( 'collection-item' );
        itemElm.appendChild( img );
        flexElm.appendChild( itemElm );
        this.items.push( itemElm );
      });
      this.dom = flexElm;
    }
    return this.dom;
  }

  check ( index ) {
    const max = this.items.length;
    return ( index < 0 || index >= max ) ? false : true;
  }

  rewind () {
    this.head = this.current - 1;
  }

  forward () {
    this.head = this.current + 1;
  }

  get head () {
    return this.items[ this.current ];
  }

  set head ( index ) {
    const current = this.check( index ) ? index : this.current;

    this.current = current;
    setHeadHash( index );
  }
}
